import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard/dashboard.service';
import { DistancePipe } from './activity/distance.pipe';
import { TimePipe } from './activity/time.pipe';
import { CarouselComponent } from './carousel/carousel.component';
import { ActivityComponent } from './activity/activity.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RegisterComponent } from './register/register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { StravaComponent } from './strava/strava.component';
import { PageNotFoundComponent } from './pagenotfound/page-not-found.component';
import { NewactivityComponent } from './newactivity/newactivity.component';
import { AuthGuard, AuthGuardHomepage } from './guard/auth-guard.service'
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AdventureComponent } from './adventure/adventure.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatSelectModule } from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import { DialogOverviewExampleDialog } from './newactivity/newactivity.component';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {IsInfo} from './_helpers/isInfo';
import { SettingsComponent } from './settings/settings.component'
import {MatTabsModule} from '@angular/material/tabs';
import { AddressComponent } from './address/address.component';
import { AppconnectComponent } from './appconnect/appconnect.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { ConfirmemailComponent } from './confirmemail/confirmemail.component';
import { PaymentComponent } from './payment/payment.component';
import { PremiumComponent } from './premium/premium.component';
import {MatStepperModule} from '@angular/material/stepper';
import { RetrieveComponent } from './retrieve/retrieve.component';
import { StatusComponent } from './status/status.component';
import {MatTableModule} from '@angular/material/table';
import {MatListModule} from '@angular/material/list';
import { HomepageComponent } from './homepage/homepage.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ShellComponentComponent } from './shell-component/shell-component.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ContactComponent } from './contact/contact.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    DistancePipe,
    TimePipe,
    CarouselComponent,
    ActivityComponent,
    RegisterComponent,
    StravaComponent,
    NewactivityComponent,
    PageNotFoundComponent,
    AdventureComponent,
    DialogOverviewExampleDialog,
    SettingsComponent,
    AddressComponent,
    AppconnectComponent,
    ConfirmemailComponent,
    PaymentComponent,
    PremiumComponent,
    RetrieveComponent,
    StatusComponent,
    HomepageComponent,
    ShellComponentComponent,
    TermsComponent,
    PrivacyComponent,
    ContactComponent
    
  ],
  imports: [
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSelectModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSnackBarModule,
    MatTabsModule,
    MatTooltipModule,
    MatStepperModule, 
    MatTableModule,
    MatListModule,
    RecaptchaModule
   ],
  providers: [DashboardService, AuthGuard, AuthGuardHomepage, IsInfo, Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
